import { AntTag, defaultTheme, Icons, Text } from '@agro-club/agroclub-shared'
import { DASH } from 'modules/constants'
import { UsContract, UsContractStatuses, UsContractTypes } from 'modules/domain/usContracts/types'
import { formatQuantity } from 'modules/utils/numbers/formatQuantity'
import { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { SelectableWrapper } from 'views/components/Card/Wrapper'
import { DeliveryPeriodData } from 'views/components/DealCard/DeliveryPeriod'

const Content = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px 0;
`

export const WrapperCard = styled(SelectableWrapper)`
  &:hover {
    background-color: ${defaultTheme.color.primary8a};
  }
  transition: all 0.3s ease;
  // hack to keep cad size when scroll is visible
  min-width: 298px;
`

const TagsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`
const LimitTags = styled.div`
  display: flex;
  gap: 9px;

  svg {
    width: 16px;
    height: 16px;
  }
`
type Props = {
  contract: UsContract
  onClick: (contract: UsContract) => void
  isSelected: boolean
}

export const ContractCard: FC<Props> = memo(({ contract, onClick, isSelected }) => {
  const { t } = useTranslation('usContracts')
  const isCLOk = contract.is_credit_limit_met || contract.approved_credit_limit_overdraft
  const isPositionOk = contract.is_position_limit_met || contract.approved_position_limit_overdraft
  return (
    <WrapperCard selected={isSelected} onClick={() => onClick(contract)}>
      <Content>
        <TagsContainer>
          {contract.contract_type === UsContractTypes.sale ? (
            <AntTag color="blue">{t('contractTypes.sale')}</AntTag>
          ) : (
            <AntTag color="purple">{t('contractTypes.purchase')}</AntTag>
          )}
          <LimitTags>
            {contract.status == UsContractStatuses.new && (
              <>
                <AntTag color={isCLOk ? 'green' : 'white'}>
                  {isCLOk && <Icons.IconDone />}
                  {t('creditLimitShort')}
                </AntTag>
                <AntTag color={isPositionOk ? 'green' : 'white'}>
                  {isPositionOk && <Icons.IconDone />}
                  {t('positionLimitShort')}
                </AntTag>
              </>
            )}
          </LimitTags>
        </TagsContainer>
        <div>
          <Text typography="accentLarge">{contract.company.name}</Text>
          <Text typography="bodyLarge" color="secondary">
            {contract.market_zone?.name ?? DASH}
          </Text>
        </div>
        <Text typography="bodyLarge">
          {contract.product.title}, {formatQuantity(contract.calculated_quantity)}
        </Text>
        <DeliveryPeriodData data={{ start_date: contract.start_date, end_date: contract.end_date }} />
        <Text typography="bodyLarge">{contract.address?.short_address}</Text>
      </Content>
    </WrapperCard>
  )
})
